const BASE_URL = process.env.VUE_APP_API_URL
const duration = 100
const timeout = 100
const phoneMask = '+#(###) ### ## ##'

export { duration, timeout, BASE_URL, phoneMask }
